import React from "react";
import {useTranslation} from "next-i18next";

/**
 * Product-Types
 * @type {string[]}
 */
const types = [
    'all',
    'food'
];

/**
 *
 * @returns {JSX.Element}
 * @constructor
 */
export default function Select ({ includeAll, value })
{
    // init
    const { t } = useTranslation();

    // remove the all-option if necessary
    if(!includeAll && 'all' === types[0]) {
        types.shift();
    }

    // render
    return (
        <>
            <select className="form-select" id="type" name="type" defaultValue={value}>
                {types.map((option) =>
                    <option key={option} value={option}>{t(option)}</option>
                )}
            </select>
        </>
    );
}